/**
 * @generated SignedSource<<c2ae3e7cd7ab8239cdfea801e873dcc4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HotelImportsTableRow_import$data = {
  readonly createdAt: string | null;
  readonly currentRow: number;
  readonly hotelsImported: number;
  readonly id: string;
  readonly totalRows: number;
  readonly updatedAt: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"HotelImportStatus_hotelImport">;
  readonly " $fragmentType": "HotelImportsTableRow_import";
};
export type HotelImportsTableRow_import$key = {
  readonly " $data"?: HotelImportsTableRow_import$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelImportsTableRow_import">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HotelImportsTableRow_import",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalRows",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentRow",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hotelsImported",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HotelImportStatus_hotelImport"
    }
  ],
  "type": "HotelImport",
  "abstractKey": null
};

(node as any).hash = "b917064fdbface7f0d09cf78cdb41d1e";

export default node;
